import { render, staticRenderFns } from "./UiTags.vue?vue&type=template&id=6ee10018&"
import script from "./UiTags.vue?vue&type=script&lang=js&"
export * from "./UiTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports